import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

import { computed } from 'vue';

type SkeletonVariantType = typeof CompassEnums.SkeletonVariantType;
type SkeletonSizeType = typeof CompassEnums.SkeletonSize;
type TableSizeType = typeof CompassEnums.TableSize;

interface TableLoadingColumn {
    width?: number;
    skeleton?: SkeletonVariantType[keyof SkeletonVariantType];
    skeletonSize?: SkeletonSizeType[keyof SkeletonSizeType];
    fitContent?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TableLoading',
  props: {
    columns: { default: undefined },
    rowCount: { default: 10 },
    size: { default: undefined }
  },
  setup(__props: any) {

const props = __props;

const resolvedColumns = computed<TableLoadingColumn[]>(() => {
    if (props.columns) {
        return props.columns;
    }

    const medium = props.size === CompassEnums.TableSize.MEDIUM;
    const { SkeletonSize } = CompassEnums;
    const size = medium ? SkeletonSize.MEDIUM : SkeletonSize.LARGE;

    return [{ skeletonSize: size }];
});

return (_ctx: any,_cache: any) => {
  const _component_CompassTableHeadCell = _resolveComponent("CompassTableHeadCell")!
  const _component_CompassTableHead = _resolveComponent("CompassTableHead")!
  const _component_CompassSkeleton = _resolveComponent("CompassSkeleton")!
  const _component_CompassTableBodyCell = _resolveComponent("CompassTableBodyCell")!
  const _component_CompassTableRow = _resolveComponent("CompassTableRow")!
  const _component_CompassTableBody = _resolveComponent("CompassTableBody")!
  const _component_CompassTable = _resolveComponent("CompassTable")!

  return (_openBlock(), _createBlock(_component_CompassTable, {
    class: "table-loading",
    size: __props.size
  }, {
    default: _withCtx(() => [
      _createVNode(_component_CompassTableHead, { class: "table-loading__head" }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(resolvedColumns.value, (col, index) => {
            return (_openBlock(), _createBlock(_component_CompassTableHeadCell, {
              id: `loading-col-${index}`,
              key: index,
              defaultWidth: col.width,
              fitContent: col.fitContent
            }, null, 8 /* PROPS */, ["id", "defaultWidth", "fitContent"]))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_CompassTableBody, null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.rowCount, (row) => {
            return (_openBlock(), _createBlock(_component_CompassTableRow, { key: row }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(resolvedColumns.value, (col, index) => {
                  return (_openBlock(), _createBlock(_component_CompassTableBodyCell, {
                    key: index,
                    idColumn: `loading-col-${index}`
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CompassSkeleton, {
                        variant: col.skeleton,
                        size: col.skeletonSize
                      }, null, 8 /* PROPS */, ["variant", "size"])
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["idColumn"]))
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              _: 1 /* STABLE */
            }))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["size"]))
}
}

})